module.exports = __webpack_public_path__ + "img/Clear_ice.a7814d9f.jpg";